import { getHyperLinkAndCaption, } from '@thoughtspot/browser-util';
import { extractCaptionTitleAndLink } from '@thoughtspot/formatter-service';
import _ from 'lodash';
function checkAndFetchHyperLinkAndCaption(value) {
    const captionAndLink = extractCaptionTitleAndLink(value);
    if (captionAndLink) {
        return getHyperLinkAndCaption(captionAndLink.caption, captionAndLink.link);
    }
    return undefined;
}
export function generateHyperlinkContainer(cellValue) {
    let isCellHyperLink = false;
    let title;
    const container = document.createElement('span');
    if (_.isArray(cellValue)) {
        cellValue.forEach((value, index) => {
            const hyperLinkAndCaption = checkAndFetchHyperLinkAndCaption(value);
            if (hyperLinkAndCaption) {
                isCellHyperLink = true;
                container.appendChild(hyperLinkAndCaption.hyperlink);
                const comma = document.createTextNode(', ');
                container.appendChild(comma);
                if (index > 0) {
                    title = `${title}, ${hyperLinkAndCaption.caption}`;
                }
                else {
                    title = hyperLinkAndCaption.caption;
                }
            }
        });
        if (isCellHyperLink) {
            container.removeChild(container.lastChild);
        }
    }
    else {
        const hyperLinkAndCaption = checkAndFetchHyperLinkAndCaption(cellValue);
        if (hyperLinkAndCaption) {
            isCellHyperLink = true;
            container.appendChild(hyperLinkAndCaption.hyperlink);
            title = hyperLinkAndCaption.caption;
        }
    }
    if (isCellHyperLink) {
        return { hyperlinkElement: container, title };
    }
    return { hyperlinkElement: null, title: cellValue };
}
//# sourceMappingURL=pivot.hyperlink.util.js.map